











import { defineComponent } from '@nuxtjs/composition-api'
import useProductPage from '~/composables/useProductPage'
import {SfIcon} from '@storefront-ui/vue'
export default defineComponent({
    components:{
        SfIcon
    },
    setup() {
        const { product } = useProductPage();
        return {
            product,
            isOdd: product.value.features.length%2 != 0
        }
    },
})
